import styled from '@emotion/styled'
import InformationBlock from '@mmsg/louie/dist/InformationBlock/InformationBlock'
import { ITheme } from 'utils/type'

interface IInputProps {
  theme: ITheme
}

export const StyledEstimateItemInfoBlock = styled(
  InformationBlock
)<IInputProps>`
  label: StyledEstimateItemInfoBlock;
  border-width: 2px;
  border: ${(props) => props.theme.colors.borderColor};
  border-style: solid;
  border-radius: 5px;
`
